export function childrensBookPhysicalPageSpan(
  unit = {}
) {
  return unit?.unitType ===
    "double_page_spread"
    ? 2
    : 1;
}


export function buildChildrensBookPhysicalPageItems(
  units = []
) {
  const sourceUnits =
    Array.isArray(units)
      ? units
      : [];

  let nextPage = 1;

  return sourceUnits.map(
    (
      unit,
      index
    ) => {
      const isSpread =
        unit?.unitType ===
          "double_page_spread";

      /*
       * Writer-facing physical pagination.
       *
       * A left-to-right two-page spread begins on an
       * even verso page. If the next available page is
       * odd, that odd page is reserved as an alignment
       * blank before the spread.
       *
       * Internal unit ids, array positions and legacy
       * planning pageNumber values do not determine the
       * writer-facing physical page label.
       */
      const alignmentPage =
        isSpread &&
        nextPage % 2 === 1
          ? nextPage
          : null;

      if (alignmentPage) {
        nextPage += 1;
      }

      const pageStart =
        nextPage;

      const pageEnd =
        pageStart +
        childrensBookPhysicalPageSpan(
          unit
        ) -
        1;

      nextPage =
        pageEnd + 1;

      return {
        unit,
        index,
        pageStart,
        pageEnd,
        alignmentPage,
      };
    }
  );
}


export function childrensBookWriterPageLabel(
  item
) {
  if (!item) {
    return "";
  }

  const pageStart =
    Number(
      item.pageStart
    );

  const pageEnd =
    Number(
      item.pageEnd
    );

  if (
    !Number.isInteger(pageStart) ||
    pageStart < 1 ||
    !Number.isInteger(pageEnd) ||
    pageEnd < pageStart
  ) {
    return "";
  }

  if (
    pageEnd >
    pageStart
  ) {
    return `Pages ${pageStart}–${pageEnd}`;
  }

  return `Page ${pageStart}`;
}


export function childrensBookTotalPhysicalPages(
  units = []
) {
  const items =
    buildChildrensBookPhysicalPageItems(
      units
    );

  return items.length
    ? items[
        items.length - 1
      ].pageEnd
    : 0;
}
